import * as types from '../constants/analyticsConstants';
import { LOGOUT } from '../constants/authConstants';

const initialState = {
  tasksIncomePerMonth: [],
  partsIncomePerMonth: [],
  totalTasksIncome: {},
  totalHours: {},
  totalVisits: {},
  totalVehicles: {},
  loading: true,
};

const analyticsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_ANALYTICS:
      return {
        ...initialState,
      };
    case types.GET_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        tasksIncomePerMonth: payload.tasksIncomePerMonth,
        partsIncomePerMonth: payload.partsIncomePerMonth,
        totalTasksIncome: payload.totalTasksIncome,
        totalHours: payload.totalHours,
        totalVisits: payload.totalVisits,
        totalVehicles: payload.totalVehicles,
      };
    case types.GET_ANALYTICS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_ANALYTICS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};

export default analyticsReducer;
